import {Image} from "@chakra-ui/react";
import {ImageProps} from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import MKS_LOGO from "./mks-logo-no-bg.png";

const MksLogo = (props: ImageProps) => (
  <Link to="/">
    <Image
      src={MKS_LOGO}
      height={props.height}
      width={props.width}
      cursor="pointer"
    />
  </Link>
);

export default MksLogo;
